import SmartTableHeader from './smart-table-header';
import './smart-table-header.scss';

export default SmartTableHeader;
